module.exports = __webpack_public_path__ + "media/assets/document-38c596c45fd62fc608fd4cf6abac1687.svg";